/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ServiceAccountsControllerCreateKeyMutationRequest, ServiceAccountsControllerCreateKeyMutationResponse, ServiceAccountsControllerCreateKeyPathParams, ServiceAccountsControllerCreateKeyQueryParams, ServiceAccountsControllerCreateKey400, ServiceAccountsControllerCreateKey401, ServiceAccountsControllerCreateKey403 } from "../../models/serviceAccountsController/ServiceAccountsControllerCreateKey";

function getServiceAccountsControllerCreateKeyUrl(orgId: ServiceAccountsControllerCreateKeyPathParams["orgId"]) {
  const res = { method: 'POST', url: `/api/v1/organizations/${orgId}/api-keys` as const }  
  return res
}

/**
 * @summary Create a key; the secret is returned only once
 * {@link /api/v1/organizations/:orgId/api-keys}
 */
export async function serviceAccountsControllerCreateKey(orgId: ServiceAccountsControllerCreateKeyPathParams["orgId"], data: ServiceAccountsControllerCreateKeyMutationRequest, params?: ServiceAccountsControllerCreateKeyQueryParams, config: Partial<RequestConfig<ServiceAccountsControllerCreateKeyMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<ServiceAccountsControllerCreateKeyMutationResponse, ResponseErrorConfig<ServiceAccountsControllerCreateKey400 | ServiceAccountsControllerCreateKey401 | ServiceAccountsControllerCreateKey403>, ServiceAccountsControllerCreateKeyMutationRequest>({ method : "POST", url : getServiceAccountsControllerCreateKeyUrl(orgId).url.toString(), params, data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}